module.exports = __webpack_public_path__ + "assets/img/desc-02-bff22e95.png";